export const MAX_COUNTER_CHARACTERS = 80
export const NOT_AVAILABLE = 'N/A'
